 const MinusIcon = ({ fill="#1A56DB", width='14', height='2' }) => {
  return (
    <svg width={width}  height={height} viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.25 1.74995C1.0375 1.74995 0.859375 1.67805 0.715625 1.53425C0.571875 1.39043 0.5 1.21223 0.5 0.99965C0.5 0.78705 0.571875 0.608958 0.715625 0.465375C0.859375 0.321791 1.0375 0.25 1.25 0.25H12.75C12.9625 0.25 13.1406 0.3219 13.2843 0.4657C13.4281 0.609516 13.5 0.787717 13.5 1.0003C13.5 1.2129 13.4281 1.39099 13.2843 1.53457C13.1406 1.67816 12.9625 1.74995 12.75 1.74995H1.25Z" fill={fill}/>
    </svg>
  );
};

export default MinusIcon;
